import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { updateIri } from 'src/containers/ProjectDiagram/utils/updateIris/updateIri';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useUpdateIri = (oldIri?: string) => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    (newIri: string) => {
      if (!diagram || !oldIri || newIri === oldIri) {
        return;
      }

      dispatch(
        uiSlice.actions.updatedEntityDrawerValue({
          projectId,
          prevEntityValue: oldIri,
          entityValue: newIri,
        })
      );

      dispatch(
        uiSlice.actions.updatedMappingFiltersIri({
          projectId,
          prevIri: oldIri,
          nextIri: newIri,
        })
      );

      commitDiagramModel(diagram, updateIri(oldIri, newIri));
    },
    [diagram, dispatch, oldIri, projectId]
  );
};
